module.exports = __webpack_public_path__ + "static/media/seveth.370d9eaf.gif";